import { render, staticRenderFns } from "./GeneralIndicators.vue?vue&type=template&id=23e9e3e2&scoped=true&"
import script from "./GeneralIndicators.vue?vue&type=script&lang=js&"
export * from "./GeneralIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9e3e2",
  null
  
)

export default component.exports